import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import { useRouter } from 'next/router';
import useTrans from '../../hooks/useTrans';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { fetchApi } from '@/utils/api';
import MetaSeo from '../MetaSeo';
import CompoundedSpace from 'antd/lib/space';
export default function Product(props) {
  var setting = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    infinite: false,
    // centerMode: true,
    speed: 1000,
    arrows: false,
    prevArrow: '',
    nextArrow: '',
    dots: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          slidesToShow: 1,
          // centerMode: true,
          centerPadding: '84px',
        },
      },
    ],
  };
  const Setting = slideData => {
    let listImg = slideData.list_image;
    console.log('slideData', listImg);
    return (setting = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      infinite: true,
      // centerMode: true,
      speed: 500,
      arrows: false,
      prevArrow: '',
      nextArrow: '',
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            infinite: true,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '84px',
          },
        },
      ],
      customPaging: function(i) {
        return (
          <button>
            <img src={listImg[i].newImg}></img>
          </button>
        );
      },
      appendDots: dots => {
        console.log('hhh', dots);
        return (
          <div
          // style={{
          //   backgroundColor: "#ddd",
          //   borderRadius: "10px",
          //   padding: "10px"
          // }}
          >
            <div className="imgDots"> {dots} </div>
            <div className="barDots"> {dots} </div>
            {/* {dots.map(item => {
              console.log('ll', item);
              return (
                <div className='barDots'>

                  1
                </div>
              )

            })} */}
          </div>
        );
      },
    });
  };
  const trans = useTrans();
  const imageBg = {
    s3GmluQwmKacqVa1: '/assets/img/products/img_text_egate_03.png',
    '2KdEnQkuvMHWOMU1': '/assets/img/products/img_text_egate_02.png',
    sOb8PjJ0o6zuNjBl: '/assets/img/products/img_text_egate_01.png',
  };
  const [data, setData] = useState([]);
  // useEffect(function () {
  //   fetchApi('/app/product/get-list-product').then(res => {
  //     setData(res.data.rows);
  //   });
  // }, []);

  const router = useRouter();
  useEffect(() => {
    console.log(router.locale, 'test');
    fetchApi('/app/product/get-list-product', 'get', {
      sign: router.locale,
    }).then(res => {
      setData(res.data.rows);
    });
  }, [router.locale]);
  const dataSEO = {
    title: `${trans.layout.product} | EYEFIRE`,
    description: trans.seo.product.description,
  };
  console.log('dataaa', data);
  return (
    <>
      <MetaSeo {...dataSEO} />
      <section className="p-products">
        <div className="c-big-banner">
          <div className="c-big-banner__image">
            <img
              className="w-100 item-pc"
              src="/assets/img/products/img_big-banner.webp"
              alt=""
            />
            <img
              className="item-sp w-100"
              src="/assets/img/products/img_big-banner-sp.webp"
              alt=""
            />
          </div>
          <div className="c-big-banner__inner">
            <div className="l-container">
              <div className="c-big-banner__content">
                <h3>{trans.product.product}</h3>
                <p className="product-lh">{trans.product.product_des}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-products__list">
          {data.map((item, idx) => {
            return (
              <div
                className={`p-products__block p-products__block-0${idx +
                  1} p-products__block-sp`}
              >
                <div className="l-container">
                  <div className="l-row">
                    <div className="l-col p-products__block-left">
                      <div className="p-products__block-slider slider-content">
                        <Slider {...Setting(item)}>
                          {item.list_image.map(children => (
                            <div
                              className={`p-products__block-item product-it-${idx}`}
                            >
                              <img
                                src={children.newImg}
                                alt={children.title}
                                title={children.title}
                              />
                            </div>
                          ))}
                        </Slider>
                      </div>
                      <div className="p-products__block-text">
                        <img
                          src={
                            imageBg[item.group_id] ||
                            '/assets/img/products/img_text_egate_01.png'
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="l-col p-products__block-right">
                      <div className="p-home__products-item">
                        <div className="p-home__products-right-inner">
                          <div>
                            <h3>{item.name}</h3>
                            <p>{item.description}</p>
                          </div>
                          <ul className="p-home__products-features">
                            {item.description_sub.map(sub => (
                              <li>
                                <div className="p-home__products-features-icon">
                                  <img
                                    src={sub?.image}
                                    alt={sub.description}
                                    title={sub.title}
                                  />
                                </div>
                                <div className="p-home__products-features-info">
                                  <h5>{sub.title}</h5>
                                  <p>{sub.text}</p>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
